import * as React from 'react';
import { Modal } from '../../Modal';
import { Flex } from '../FlexHelpers';
import { UserSelectorPanel } from './UserSelectorPanel';
import { PublicAmorgUser } from '../../../amorg-common';
import { getUsers } from '../../../api/userClientApi';
import { FullUserAvatar } from '../../avatar/FullUserAvatar';
import { NoUserAvatar } from '../../avatar/NoUserAvatar';

type UserSelectorAvatarButtonProps = {
    disabled?: boolean,
    hideEdit?: boolean,
    disallowEmpty?:boolean,
    userFilter?: (user:PublicAmorgUser) => boolean,
    selectedUserId?:string,
    noSelectionText?:string,
    onUserChange: (user:PublicAmorgUser|null) => void,
}
export function UserSelectorAvatarButton(props:UserSelectorAvatarButtonProps):JSX.Element
{ 
    const [showModal, setShowModal] = React.useState(false);
    const [users, setUsers] = React.useState<PublicAmorgUser[]>(null);

    React.useEffect(() =>
    {
        const getData = async () =>
        {
            let users = await getUsers(false, false);
            if (props.userFilter) {
                users = users.filter(props.userFilter);
            }
            setUsers(users);
        };
        getData();
    }, []);

    function handleSelectionChanged(userId:string) {
        props.onUserChange(userId === '' ? null : users.find(u => u.id === userId) || null);
        setShowModal(false);
    }

    const selectedUser = users?.find(u => u.id === props.selectedUserId);

    return (
        <>
            <Flex alignItems='center' gap={4}>
                    {selectedUser
                    ?   <FullUserAvatar
                            user={selectedUser}
                            size="32px"
                            onClick={
                                props.hideEdit || props.disabled
                                    ? undefined
                                    : () => setShowModal(true)}
                        />

                    :  <NoUserAvatar
                            tooltip={props.disabled ? "Ingen valgt" : "Vælg bruger"}
                            onClick={
                                props.hideEdit || props.disabled
                                    ? undefined
                                    : () => setShowModal(true)} />
                }
            </Flex>
            {users !== null &&
                <Modal
                    showModal={showModal}
                    title={'Vælg ejer'}
                    onCancel={() => setShowModal(false)}
                    content={
                        <Flex flexDirection='column' gap={16}>
                            <UserSelectorPanel
                                users={users}
                                showNone={!props.disallowEmpty}
                                onSelectionChanged={handleSelectionChanged}
                            />
                        </Flex>
                    }
                />
            }
        </>
    );
}